export default __webpack_public_path__ + "static/pic1-3b7acb497a64e7decfdf8af2a5e3e635.webp";